export const languageConst = {
  lang: ['en-English', 'es-Español'],
};
